import { render, staticRenderFns } from "./ClipboardId.vue?vue&type=template&id=896bbc7a"
import script from "./ClipboardId.vue?vue&type=script&lang=js"
export * from "./ClipboardId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports